import { useSession } from "@outschool/ui-auth";

import { useRequiresMembershipForEnrollment } from "./useRequiresMembershipForEnrollment";

export function useShowCredits() {
  const {
    requiresMembershipForEnrollment,
    requiresEsaMembershipForEnrollment
  } = useRequiresMembershipForEnrollment();
  const { currentUser } = useSession();
  return (
    requiresMembershipForEnrollment ||
    requiresEsaMembershipForEnrollment ||
    currentUser?.canPayWithSubscriptionCredits
  );
}
